import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../pipes';
import { EnableDirectoryDropDirective } from './enable-directory-drop.directive';
import { HideListFilesControlDirective } from './hide-list-files-control.directive';
import { InputFileComponent } from './input-file.component';

@NgModule({
    imports: [TwcModule, FormsModule, CommonModule, TranslateModule, PipesModule],
    declarations: [InputFileComponent, HideListFilesControlDirective, EnableDirectoryDropDirective],
    exports: [InputFileComponent],
})
export class InputFileModule {}
